<template>
  <div class="navigation-toggle-button-wrapper">
    <button
      id="navigation-toggle-button"
      title="Меню"
      v-on:click="$emit('toggle-main-navigation')"
    >
      <span v-bind:class="['hamburger-icon', { active: isActive }]">
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'NavigationMainToggleButton',
  props: ['isActive'],
  data: function () {
    return {}
  }
}
</script>

<style lang="scss">
  $transition-duration: 0.3s;

  @function hamburger-icon-transition($property, $with-delay: true) {
    /* transition: <property> <duration> <timing-func> <delay> */
    @if ($with-delay) {
      @return $property $transition-duration ease $transition-duration;
    } @else {
      @return $property $transition-duration ease 0s;
    }
  }

  .navigation-toggle-button-wrapper {
    @include media("<=desktop") { display: block; };
    @include media(">desktop") { display: none; };
    line-height: $the-header-main-height;
    position: fixed;
    left: 10px;
    height: $the-header-main-height;
  }
  #navigation-toggle-button {
    display: inline-block;
    vertical-align: top;
    height: 100%;
    padding: 0 15px;
    border: 0;
    outline: none;
    background-color: transparent;
    cursor: pointer;
  }
  .hamburger-icon {
    vertical-align: middle;
    position: relative;
    transition: hamburger-icon-transition(
        background-color, $with-delay: true);
  }
  .hamburger-icon,
  .hamburger-icon:before,
  .hamburger-icon:after {
    background-color: $active-link-color;
    display: inline-block;
    height: 2px;
    width: 30px;
  }
  .hamburger-icon:before,
  .hamburger-icon:after {
    content: "";
    position: absolute;
    left: 0;
  }
  .hamburger-icon:before {
    transition:
      hamburger-icon-transition(top, $with-delay: true),
      hamburger-icon-transition(transform, $with-delay: false);
    top: -10px;
  }
  .hamburger-icon:after {
    transition:
      hamburger-icon-transition(bottom, $with-delay: true),
      hamburger-icon-transition(transform, $with-delay: false);
    bottom: -10px;
  }
  .hamburger-icon.active:before {
    top: 0;
    transform: rotate(45deg);
    transition:
      hamburger-icon-transition(top, $with-delay: false),
      hamburger-icon-transition(transform, $with-delay: true);
  }
  .hamburger-icon.active:after {
    bottom: 0;
    transform: rotate(-45deg);
    transition:
      hamburger-icon-transition(bottom, $with-delay: false),
      hamburger-icon-transition(transform, $with-delay: true);
  }
  .hamburger-icon.active {
    transition: hamburger-icon-transition(
        background-color, $with-delay: false);
    background-color: $default-background-color;
  }
</style>



// WEBPACK FOOTER //
// src/components/the-header/navigation-main/NavigationMainToggleButton.vue